/**
 * 日期格式化工具函數
 */

/**
 * 格式化日期時間為本地字串
 * @param date - 日期對象或 undefined
 * @param options - 格式化選項
 * @returns 格式化後的日期字串，如果日期無效則返回 "-"
 */
export function formatDateTime(
  date: Date | undefined | null,
  options?: {
    locale?: string;
    dateStyle?: "full" | "long" | "medium" | "short";
    timeStyle?: "full" | "long" | "medium" | "short";
  }
): string {
  if (!date) return "-";
  
  try {
    const dateObj = date instanceof Date ? date : new Date(date);
    if (isNaN(dateObj.getTime())) return "-";
    
    const {
      locale = "zh-TW",
      dateStyle = undefined,
      timeStyle = undefined,
    } = options || {};
    
    if (dateStyle || timeStyle) {
      return dateObj.toLocaleString(locale, {
        dateStyle,
        timeStyle,
      });
    }
    
    return dateObj.toLocaleString(locale);
  } catch (error) {
    console.error("Date formatting error:", error);
    return "-";
  }
}

/**
 * 格式化日期為本地日期字串（不包含時間）
 * @param date - 日期對象或 undefined
 * @param locale - 語言環境，默認為 "zh-TW"
 * @returns 格式化後的日期字串，如果日期無效則返回 "-"
 */
export function formatDate(
  date: Date | undefined | null,
  locale: string = "zh-TW"
): string {
  if (!date) return "-";
  
  try {
    const dateObj = date instanceof Date ? date : new Date(date);
    if (isNaN(dateObj.getTime())) return "-";
    
    return dateObj.toLocaleDateString(locale);
  } catch (error) {
    console.error("Date formatting error:", error);
    return "-";
  }
}

/**
 * 格式化觀看時間（秒）為可讀字串
 * @param seconds - 總秒數
 * @returns 格式化後的時間字串，例如 "2 小時 30 分鐘" 或 "45 分鐘"
 */
export function formatWatchTime(seconds: number | undefined | null): string {
  if (!seconds || seconds <= 0) return "0 分鐘";
  
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  
  if (hours > 0) {
    return `${hours} 小時 ${minutes} 分鐘`;
  }
  return `${minutes} 分鐘`;
}

